<!--

-->
<div class="tw:w-full tw:px-[15px] tw:mx-auto tw:pb-6">
  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0">
      <div>
        <div class="tw:w-full tw:p-0 tw:m-0">
          <h1>Get yourself ready for online tuition</h1>
        </div>
        <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-2">
          <label class="sub-text">We understand that adapting to a new platform can be a bit challenging and its important to make sure you are able to use the online tools provided.</label>
          <br />
        </div>
        <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-2">
          <label class="sub-text">Before any tuition starts please ensure you have run the digital classroom network tests accessible below as you may need to contact your IT providers to amend firewall restrictions.</label>
        </div>
        <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-6">
          <label class="sub-text">Click on the following to run the tests:</label>
          <br />
          <a class="btn btn-primary tw:mt-4 custom-button-width"
            [href]="'https://digitalclassroom.' + companyUrl + '.com/help/network-requirements'"
          target="_blank">Network Test</a>
        </div>
        <div class="tw:w-full tw:p-0 tw:m-0 tw:mt-6">
          <label class="sub-text">Anyone using the classroom needs to test accessibility for live video and audio streaming,
          please click below:</label>
          <br />
          <a class="btn btn-primary tw:mt-4 custom-button-width"
          [href]="'https://digitalclassroom.' + companyUrl + '.com/help/browser-test'" target="_blank">Browser Test</a>
        </div>
      </div>
</div>

</div>
